import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyD1wPuDsUZVOx0c0GHzVSYGurLXSVJnkkg",
  authDomain: "muskan-software-website.firebaseapp.com",
  projectId: "muskan-software-website",
  storageBucket: "muskan-software-website.firebasestorage.app",
  messagingSenderId: "365379008150",
  appId: "1:365379008150:web:5c41d79a2018b3ecdff4b7",
  measurementId: "G-1N9Q52XV39",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Services
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
const analytics = getAnalytics(app);

export { auth, db, storage, analytics };
export default app;
